/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Compiled, { css as compiledCSS } from '../compiled/components/single-value';
import Emotion, { css as emotionCSS } from '../emotion/components/single-value';
export var css = function css(props) {
  return fg('compiled-react-select') ? compiledCSS() : emotionCSS(props);
};
var SingleValue = function SingleValue(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(Compiled, props) : /*#__PURE__*/React.createElement(Emotion, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default SingleValue;